import {Action, Dispatch} from 'redux';
import client from '../../client';
import {defaultGet} from './all';
import {TeamActionTypes} from './types';

export function fetchPositions(
    dispatch: Dispatch<Action<TeamActionTypes>>
) {
    defaultGet(
        dispatch,
        TeamActionTypes.FETCH_POSITIONS_SUCCESS,
        TeamActionTypes.FETCH_POSITIONS_ERROR,
        TeamActionTypes.FETCH_POSITIONS,
        client().getPositions,
        false,
        false,
    );
}
